import { defineStore } from 'pinia';

/**
 * Global connector enablement state.
 *
 * Connectors are instance-level resources (the active set is pushed to the
 * OpenClaw instance via `setMyConnectorsActive`), so unlike skills and
 * knowledge bases they are NOT bound to an individual conversation. This store
 * keeps the enabled set in a single persisted location and is shared across
 * all composer sessions.
 */
export const useConnectorStore = defineStore('connector', () => {
  const enabledConnectorIds = ref<string[]>([]);

  function setEnabledConnectorIds(ids: string[]) {
    enabledConnectorIds.value = [...ids];
  }

  function toggleConnectorId(id: string) {
    const index = enabledConnectorIds.value.indexOf(id);
    if (index >= 0)
      enabledConnectorIds.value = enabledConnectorIds.value.filter(item => item !== id);
    else
      enabledConnectorIds.value = [...enabledConnectorIds.value, id];
  }

  return {
    enabledConnectorIds,
    setEnabledConnectorIds,
    toggleConnectorId,
  };
});
